module.exports = __webpack_public_path__ + "static/media/sfx_amb_fades_05.b27d4fb7.mp3";